export const MFA_MODAL_OPEN = 'accounts.security.mfa.open';
export const MFA_MODAL_CONTACT_ADDED = 'accounts.security.mfa.contact-added.success';
